import React from 'react';
import classNames from 'classnames';
import * as styles from './button.module.scss';

interface ButtonTypes {
  label?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const Button: React.FC<ButtonTypes & React.HTMLAttributes<HTMLButtonElement>> = ({ label, className, children, onClick }) => {
  const style = classNames(styles.oButton, ...[className]);
  return (
    <button onClick={onClick} type="button" role="button" className={style}>
      {label || children}
    </button>
  );
};

export default Button;
